/*
 * Copyright (c) Nexign, JSC, 2025.
 */
/**
 * Price section for the new campaign rateplan card
 *
 * @author Nikolay Sviridov
 * @version 1.39.0
 * @since 1.39.0
 */

import {
	DescriptionTextStyled,
	VerticalDivStyled,
	VolumesStyled,
	VolumeTextStyled,
} from '../styled/RatePlanCard2025Styled';
import type { IPriceSectionProps } from '../types/RatePlanCard2025Types';

export const PriceSection = (props: IPriceSectionProps) => {
	const { totalPrice } = props;
	return (
		<VerticalDivStyled $marginBottom={'8px'} $marginTop={'auto'}>
			<VolumesStyled $alignItems='flex-end'>
				<VolumeTextStyled
					$lineHeight='100%'
					variant='h2'
				>
                    {`${totalPrice?.value ?? ''} ${totalPrice?.unitValue ?? ''}`}
				</VolumeTextStyled>
				<DescriptionTextStyled>{totalPrice?.unitExtra ?? ''}</DescriptionTextStyled>
			</VolumesStyled>
		</VerticalDivStyled>
	);
};
